export default __webpack_public_path__ + "static/media/vegas.0fecee2c.png";